import React from 'react'
import { R } from '../../R/R'
import './Copyright.scss'

export const Copyright = () => {
	return null
	// return <div id='copyright'>
	// 	© 2022 MVP Poker LLC. All rights reserved.
	// 	<img id='fb-icon' src={R.images.logoFb} alt='facebook logo'/>
	// 	<img id='ig-icon' src={R.images.logoInsta} alt='instagram logo'/>
	// 	<img id='twitter-icon' src={R.images.logoTwitter} alt='twitter logo'/>
	// </div>
}
